import Vue from 'vue'
import App from './App.vue'

import ViewUI from 'view-design';
import 'view-design/dist/styles/iview.css';

import VueRouter from 'vue-router';
import router from './router/index.js'
import axios from './api/index.js'

// import 'fullpage.js/vendors/scrolloverflow';
// import VueFullPage from 'vue-fullpage.js';

// 引入echarts
import * as echarts from 'echarts'


Vue.config.productionTip = false

// Vue.use(VueFullPage);
Vue.use(VueRouter);
Vue.use(ViewUI);
Vue.prototype.openWindows= function(e){
	this.$router.push({
		path: '/read?id=' + e
	})
}
// The routing configuration
const RouterConfig = {
    routes: router
};

const router1 = new VueRouter(RouterConfig);

/* 路由发生变化修改页面title */
router1.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})
Vue.prototype.$echarts = echarts
new Vue({
  render: h => h(App),
  router: router1,
}).$mount('#app')
